import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: "https://id.roso-blumberg.de/",  // Stellen sicher, dass diese URL korrekt ist
  //url: process.env.VUE_APP_NOT_SECRET_CODE
  realm: "vue-realm",
  clientId: "taskflow",
});

const initKeycloak = () => {
  return new Promise((resolve, reject) => {
    keycloak.init({ onLoad: 'login-required' }).then(authenticated => {
      if (authenticated) {
        console.log('Authenticated');
        
        // Start a timer to refresh the token every minute
        setInterval(() => {
          keycloak.updateToken(60).then(refreshed => {
            if (refreshed) {
              console.log('Token refreshed');
            } else {
              console.log('Token is still valid');
            }
          }).catch(err => {
            console.error('Failed to refresh token', err);
          });
        }, 60000); // 60 Sekunden

        resolve(keycloak);
      } else {
        console.log('Not authenticated');
        window.location.reload();
      }
    }).catch(e => {
      console.error('Failed to initialize Keycloak', e);
      reject('Failed to initialize Keycloak');
    });
  });
};

export { keycloak, initKeycloak };
